export * from './inflation-hedge-content'
